<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_ii"></a><a id="page_iii"></a><i>For P again,</i><br/>
<i>With love and gratitude</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?25539fde